"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var native_1 = require("./native");
var DownloadButton_1 = require("../components/button/DownloadButton/DownloadButton");
var CachePersistence;
(function (CachePersistence) {
    CachePersistence[CachePersistence["MINUTES"] = 0] = "MINUTES";
    CachePersistence[CachePersistence["SESSION"] = 1] = "SESSION";
    CachePersistence[CachePersistence["NONE"] = 2] = "NONE";
})(CachePersistence = exports.CachePersistence || (exports.CachePersistence = {}));
var Remote = /** @class */ (function () {
    function Remote(props) {
        var _this = this;
        this.curQueue = [];
        this.downloadOrOpenDocument = function (apiUrl, docId, open, onError) {
            //apiUrl = 'http://localhost:3002' + apiUrl;
            if (open === void 0) { open = false; }
            if (!native_1.isNativeIOS && //not in native iOS app
                (!open || //download links
                    !!native_1.isMobile.any() || //mobile devices
                    (window.navigator && window.navigator.msSaveOrOpenBlob)) //Desktop IE open link
            ) {
                _this.fetch(apiUrl)
                    .then(function () {
                    return window.open(apiUrl);
                })
                    .catch(function (e) {
                    if (e.isCanceled)
                        return;
                    if (onError)
                        onError(e);
                });
            }
            else if (native_1.isNativeIOS || open) {
                return _this.fetch(apiUrl)
                    .then(function (res) {
                    var contentDisposition = res.headers.get('Content-Disposition');
                    var contentTypeHeader = res.headers.get('content-type');
                    if (contentDisposition !== null) {
                        var cdParts = contentDisposition.split(';');
                        var filenameIndex = cdParts.findIndex(function (str) {
                            return str.trim().startsWith('filename');
                        });
                        if (filenameIndex !== -1) {
                            var name_1 = cdParts[filenameIndex].split('=')[1];
                            res.blob().then(function (blob) {
                                if (contentTypeHeader !== null) {
                                    var contentType = contentTypeHeader.split(';');
                                    var fileTypeIndex = contentType.findIndex(function (str) {
                                        return str.trim().startsWith('application');
                                    });
                                    if (fileTypeIndex !== -1) {
                                        var isPdf = contentType[fileTypeIndex] === 'application/pdf'; //only attempt to open pdfs
                                        DownloadButton_1.downloadOrOpenBlob(blob, name_1, isPdf, { docId: docId });
                                    }
                                }
                                else
                                    throw new Error('Content-Type header not found');
                            });
                        }
                        else
                            throw new Error('Content-Disposition header is missing filename parameter');
                    }
                    else
                        throw new Error('Content-Disposition header not found');
                })
                    .catch(function (e) {
                    if (e.isCanceled)
                        return;
                    //if (this.logger) this.logger.error('Error downloading Document', e);
                    //store.dispatch(showNotificationToastAction(t('document.error', {})));
                    if (onError)
                        onError(e);
                });
            }
            return;
        };
        //this.logger = props.logger;
        this.persistentHeaders = props.persistentHeaders;
        this.onFetchQueueNotEmpty = props.onFetchQueueNotEmpty;
        this.onFetchQueueEmpty = props.onFetchQueueEmpty;
    }
    Remote.prototype.getPersistentHeaders = function () {
        return this.persistentHeaders;
    };
    Remote.prototype.updatePersistentHeaders = function (headers, replace) {
        if (replace === void 0) { replace = false; }
        this.persistentHeaders = replace
            ? headers
            : __assign(__assign({}, this.persistentHeaders), headers);
    };
    Remote.prototype.fetch = function (input, init) {
        if (init === void 0) { init = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var fetchId, response, queueIndex, isCacheSupported, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.curQueue.length === 0) {
                            if (this.onFetchQueueNotEmpty)
                                this.onFetchQueueNotEmpty();
                        }
                        fetchId = Date.now();
                        this.curQueue.push(fetchId);
                        init = __assign(__assign({}, init), { credentials: 'same-origin' });
                        init.headers = __assign(__assign({}, (this.persistentHeaders || {})), init.headers);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, window.fetch(input, init)
                            //if (this.logger) this.logger.info(`Called endpoint: ${input.toString()} returned with status: ${response.status}`);
                        ];
                    case 2:
                        response = _a.sent();
                        queueIndex = this.curQueue.indexOf(fetchId);
                        this.removeFromFetchQueue(fetchId);
                        isCacheSupported = 'caches' in window;
                        if (response.status === 401 && isCacheSupported)
                            caches.delete('mi-cache');
                        return [2 /*return*/, queueIndex === -1
                                ? Promise.reject({ isCanceled: true })
                                : response.status >= 400
                                    ? Promise.reject(new Error("HTTP Error: Status: " + response.status))
                                    : response];
                    case 3:
                        error_1 = _a.sent();
                        //if (this.logger) this.logger.error(`Called endpoint: ${input.toString()} returned Error`, error);
                        this.removeFromFetchQueue(fetchId);
                        return [2 /*return*/, Promise.reject(error_1)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Remote.prototype.cachedFetch = function (input, init, cacheConfig) {
        if (init === void 0) { init = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var TIMED_CACHE_NAME, SESSION_CACHE_NAME, CACHE_EXPIRY_HEADER, CACHE_INITIALIZED_MARKER, _a, cachePersistence, minutesToExpiry, forceRefresh, CACHE_NAME, isCacheSupported, cachedResponse, response, cache, sessionCacheInitialized, fetchId, request, expiryValue, expirationDateTime, currentDateTime, serverResponse, cachedResponseProps, _b, _c, _d, header, value, expiresOn, serverResponseBody, queueIndex, error_2;
            var e_1, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        TIMED_CACHE_NAME = 'mi-cache';
                        SESSION_CACHE_NAME = 'mi-session-cache';
                        CACHE_EXPIRY_HEADER = 'mi-cache-expiry';
                        CACHE_INITIALIZED_MARKER = 'cache-initialized';
                        _a = __assign({ cachePersistence: CachePersistence.NONE, minutesToExpiry: 20, forceRefresh: false }, cacheConfig), cachePersistence = _a.cachePersistence, minutesToExpiry = _a.minutesToExpiry, forceRefresh = _a.forceRefresh;
                        CACHE_NAME = cachePersistence === CachePersistence.SESSION
                            ? SESSION_CACHE_NAME
                            : TIMED_CACHE_NAME;
                        isCacheSupported = 'caches' in window &&
                            window.caches &&
                            cachePersistence !== CachePersistence.NONE;
                        sessionCacheInitialized = false;
                        if (this.curQueue.length === 0) {
                            if (this.onFetchQueueNotEmpty)
                                this.onFetchQueueNotEmpty();
                        }
                        fetchId = Date.now();
                        this.curQueue.push(fetchId);
                        init = __assign(__assign({}, init), { credentials: 'same-origin' });
                        init.headers = __assign(__assign({}, (this.persistentHeaders || {})), init.headers);
                        request = new Request(input, init);
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 18, , 19]);
                        if (!isCacheSupported) return [3 /*break*/, 9];
                        if (!(cachePersistence === CachePersistence.SESSION && sessionStorage)) return [3 /*break*/, 3];
                        sessionCacheInitialized = !!sessionStorage.getItem(CACHE_INITIALIZED_MARKER);
                        if (!!sessionCacheInitialized) return [3 /*break*/, 3];
                        return [4 /*yield*/, caches.delete(CACHE_NAME)];
                    case 2:
                        _f.sent();
                        sessionStorage.setItem(CACHE_INITIALIZED_MARKER, 'yes');
                        _f.label = 3;
                    case 3: return [4 /*yield*/, caches.open(CACHE_NAME)];
                    case 4:
                        cache = _f.sent();
                        if (!forceRefresh) return [3 /*break*/, 5];
                        cache.delete(request);
                        return [3 /*break*/, 9];
                    case 5:
                        if (!(cachePersistence === CachePersistence.MINUTES)) return [3 /*break*/, 7];
                        return [4 /*yield*/, cache.match(request)];
                    case 6:
                        cachedResponse = _f.sent();
                        if (cachedResponse) {
                            expiryValue = cachedResponse.headers.get(CACHE_EXPIRY_HEADER);
                            if (expiryValue) {
                                expirationDateTime = Date.parse(expiryValue);
                                currentDateTime = new Date().getTime();
                                // NR: clear cached request if past expiry
                                if (currentDateTime >= expirationDateTime) {
                                    cachedResponse = undefined;
                                    cache.delete(request);
                                }
                            }
                            else {
                                // NR: clear cached request in case of missing header
                                cache.delete(request);
                            }
                        }
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, cache.match(request)];
                    case 8:
                        cachedResponse = _f.sent();
                        _f.label = 9;
                    case 9:
                        if (!!cachedResponse) return [3 /*break*/, 16];
                        return [4 /*yield*/, window.fetch(input, init)
                            // @ts-ignore-next-line
                        ];
                    case 10:
                        serverResponse = _f.sent();
                        if (!(isCacheSupported && cache)) return [3 /*break*/, 14];
                        if (!(serverResponse.status === 200)) return [3 /*break*/, 12];
                        cachedResponseProps = {
                            status: serverResponse.status,
                            statusText: serverResponse.statusText,
                            headers: {},
                        };
                        if (serverResponse.headers && serverResponse.headers.entries) {
                            try {
                                for (_b = __values(serverResponse.headers.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    _d = __read(_c.value, 2), header = _d[0], value = _d[1];
                                    cachedResponseProps.headers[header] = value;
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        if (cachePersistence === CachePersistence.MINUTES) {
                            expiresOn = new Date();
                            expiresOn.setMinutes(expiresOn.getMinutes() + minutesToExpiry);
                            cachedResponseProps.headers[CACHE_EXPIRY_HEADER] = expiresOn.toUTCString();
                        }
                        return [4 /*yield*/, serverResponse.blob()
                            // NR: Populate cache
                        ];
                    case 11:
                        serverResponseBody = _f.sent();
                        // NR: Populate cache
                        cache.put(request, new Response(serverResponseBody, cachedResponseProps));
                        // NR: compose new response for immediate consumption
                        response = new Response(serverResponseBody, cachedResponseProps);
                        return [3 /*break*/, 13];
                    case 12:
                        if (serverResponse.status === 401) {
                            // NR: Delete entire cache for UnAuthorized
                            caches.delete(CACHE_NAME);
                            response = serverResponse;
                        }
                        else {
                            // NR: Delete cached request for non 2xx
                            cache.delete(request);
                            response = serverResponse;
                        }
                        _f.label = 13;
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        response = serverResponse;
                        _f.label = 15;
                    case 15: return [3 /*break*/, 17];
                    case 16:
                        response = cachedResponse;
                        _f.label = 17;
                    case 17:
                        queueIndex = this.curQueue.indexOf(fetchId);
                        this.removeFromFetchQueue(fetchId);
                        return [2 /*return*/, queueIndex === -1
                                ? Promise.reject({ isCanceled: true })
                                : response.status >= 400
                                    ? Promise.reject(new Error("HTTP Error: Status: " + response.status))
                                    : response];
                    case 18:
                        error_2 = _f.sent();
                        this.removeFromFetchQueue(fetchId);
                        // @ts-ignore-next-line
                        if (isCacheSupported && cache) {
                            cache.delete(request);
                        }
                        return [2 /*return*/, Promise.reject(error_2)];
                    case 19: return [2 /*return*/];
                }
            });
        });
    };
    Remote.prototype.removeFromFetchQueue = function (fetchId) {
        var queueIndex = this.curQueue.indexOf(fetchId);
        if (queueIndex !== -1)
            this.curQueue.splice(queueIndex, 1);
        if (this.curQueue.length === 0) {
            if (this.onFetchQueueEmpty)
                this.onFetchQueueEmpty();
        }
    };
    Remote.prototype.resetFetchQueue = function () {
        var length = this.curQueue.length;
        this.curQueue = [];
        if (length > 0 && this.onFetchQueueEmpty)
            this.onFetchQueueEmpty();
    };
    //Put methods -  for updating data
    Remote.prototype.putData = function (url, request) {
        return this.fetch(url, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        });
    };
    //Post methods
    Remote.prototype.postData = function (url, request) {
        return this.fetch(url, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        });
    };
    //Delete methods
    Remote.prototype.deleteData = function (url, request) {
        return this.fetch(url, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        });
    };
    return Remote;
}());
exports.Remote = Remote;
